import { render } from "./WhoswhoRow.vue?vue&type=template&id=65a48856"
import script from "./WhoswhoRow.vue?vue&type=script&lang=js"
export * from "./WhoswhoRow.vue?vue&type=script&lang=js"

import "./WhoswhoRow.vue?vue&type=style&index=0&id=65a48856&lang=css"

import exportComponent from "C:\\Users\\Loïc\\Downloads\\smsyou\\avalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__